module.exports = __webpack_public_path__ + "img/gsndc2782_1.bd099d5f.svg";